(ns frontend.ui.component.lp-portal.report.body.private-equity.holding.infra-company.view
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.company.financials-chart.view
    :refer [financials-chart]]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.company.overview.style :as style]
   [frontend.ui.component.lp-portal.stacked-text-group.view :refer [stacked-text-group]]
   [frontend.ui.component.lp-portal.strong-label.view :refer [strong-label]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [frontend.ui.component.lp-portal.report.company.net-debt-chart.view
    :refer [net-debt-chart-card]]
   [herb.core :refer [<class]]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]
   [frontend.ui.component.lp-portal.report.module.chart-card :as chart-card]
   [clojure.string :as s]))

(defn- overview-figures-board
  [board]
  (let [[board-label board-members] (:figures board)]
    [:div
     {:class (<class style/board)}
     [strong-label board-label]
     (map (fn [board-member]
            (let [[member-name & member-title-strs] (s/split board-member ", ")]
              [:div
               member-name
               (when member-title-strs
                 [:span
                  ", "
                  [:span
                   {:class (<class style/board-title)}
                   (s/join ", " member-title-strs)]])]))
          board-members)]))

(defn- overview-card
  [{:keys [case-overview-text
           market-development-text
           latest-development-text
           board
           overview-figures]}
   props]
  [card {}
   [:<>
    [free-text-card/free-text-section "Case Overview" case-overview-text props]
    [free-text-card/free-text-section "Market Development" market-development-text props]
    [free-text-card/free-text-section "Latest Development" latest-development-text props]]
   (into [:div]
         (concat (map #(apply stacked-text-group %)
                      (:figures overview-figures))
                 (when board
                   [(overview-figures-board board)])
                 [(text-content/optional-footnote overview-figures props)]))])

(defn infra-company
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name
                reference-date
                report-id
                overview
                financial-performance-text
                financials
                net-debt
                value-creation-plan-text
                optional-section
                valuation-text
                valuation
                distribution-yield
                ownership]}
        holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [section
      holding-name
      nil
      [:div
       [:div
        [overview-card overview props]]
       [grid/row {}
        [grid/column {:large 6}
         [free-text-card/view "Financial Performance" financial-performance-text props]]
        [grid/column {:large 6}
         [grid/row {}
          [financials-chart financials props]
          [net-debt-chart-card net-debt props]]]]
       [free-text-card/row-view "Value creation plan & exit vision" value-creation-plan-text props]
       [grid/row {}
        [free-text-card/optional-text-card optional-section props]]
       [free-text-card/row-view "Valuation principles" valuation-text props]
       [grid/row {}
        [grid/column {:large 6}
         [chart-card/view "Valuation" valuation props]]
        [grid/column {:large 6}
         [chart-card/view "Distribution Yield" distribution-yield props]]]
       [tabular-card/dynamic-table "Ownership" ownership props]]]]))
